export type optionalCoverages = {
  fireDepartmentService?: boolean;
  sinkHole?: boolean;
  ordinanceOrLaw?: boolean;
  rentalIncome?: boolean;
  workersCompensation?: boolean;
};

export const baseOptionalCoverages = {
  fireDepartmentService: false,
  sinkHole: false,
  ordinanceOrLaw: false,
  rentalIncome: false,
  workersCompensation: false,
};

export const baseOptionCoveragesId = {
  fireDepartmentService: '1066',
  sinkHole: '1067',
  ordinanceOrLaw: '1070',
  rentalIncome: '1073',
  workersCompensation: '1062',
  hurricane: '3',
  earthquake: '6',
};

export const isThisCoverageCdMandatory = (
  productCoverageList: any,
  coverageCd: any,
) => {
  return productCoverageList?.some(
    (prod: any) => prod.isMandatoryCoverage && prod.coverageCd === coverageCd,
  );
};

export const handleTgOptionalButStateMandatoryCoverages = (
  productCoverageList: any,
) => {
  const listOfCoverages = { ...baseOptionalCoverages };

  for (const coverageLabel in listOfCoverages) {
    const coverageCdOfCurrentCoverageLabel =
      baseOptionCoveragesId[coverageLabel as keyof optionalCoverages];

    if (
      isThisCoverageCdMandatory(
        productCoverageList,
        coverageCdOfCurrentCoverageLabel,
      )
    ) {
      listOfCoverages[coverageLabel as keyof optionalCoverages] = true;
    }
  }
  return listOfCoverages;
};
